import { render, staticRenderFns } from "./NomineeListComponent.vue?vue&type=template&id=65d77d1c&scoped=true"
import script from "./NomineeListComponent.vue?vue&type=script&lang=js"
export * from "./NomineeListComponent.vue?vue&type=script&lang=js"
import style0 from "./NomineeListComponent.vue?vue&type=style&index=0&id=65d77d1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d77d1c",
  null
  
)

export default component.exports